import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/* eslint-disable */
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { addJsonLdBreadcrumbList } from '../../../actions/JsonLdActions';
import { APP_BASE_URL } from '../../../define/env';
import { propArrayShape } from '../../../helpers/custom-prop-types';
import BreadcrumbColumn from './BreadcrumbColumn';
const Breadcrumb = (props) => {
    const { defaultLists, lists } = props;
    const dispatch = useDispatch();
    useEffect(() => {
        // Json-Ld のタグ表示
        const jsonLdData = lists.map(({ link, text }, i) => {
            const data = {
                '@type': 'ListItem',
                position: i + 1,
                name: text,
            };
            return link ? Object.assign(Object.assign({}, data), { item: `${APP_BASE_URL}${link}` }) : data;
        });
        dispatch(addJsonLdBreadcrumbList(jsonLdData));
    }, [lists]);
    if (defaultLists.length === 0 && lists.length === 0) {
        return null;
    }
    return (_jsx("nav", Object.assign({ className: 'breadcrumb_nav' }, { children: _jsxs("ul", Object.assign({ className: 'breadcrumb_list' }, { children: [defaultLists.map((col, index) => (_jsx(BreadcrumbColumn, { column: col }, index))), lists.map((col, index) => (_jsx(BreadcrumbColumn, { column: col }, index)))] })) })));
};
Breadcrumb.propTypes = {
    defaultLists: propArrayShape(),
    lists: propArrayShape(),
};
Breadcrumb.defaultProps = {
    defaultLists: [],
    lists: [],
};
export default Breadcrumb;
